export default __webpack_public_path__ + "4719a3f1f3a9fecfa126c63b1479d048.svg";